import { WrapperComponent, CircularBtn } from '../../../_imports.js';
import Links from '../../../../constants/links';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload, faFileAlt } from "@fortawesome/free-solid-svg-icons";
import { isIOS, isAndroid } from 'react-device-detect';
import './blog_post_header.css';

function BlogPostHeader({ isRecruiter }) {
    const getDownloadLink = () => {
        if (isIOS) return Links.appCandIos;
        if (isAndroid) return Links.appCandPlay;
        return Links.appCandPlay; // Desktop defaults to PlayStore as requested
    };

    return (
        <WrapperComponent>
            <header className="blog-post-header-action">
                <div className="header-action-container">
                    {/* Blue Part: Title */}
                    <div className="action-title-area">
                        <div className="title-content-wrapper">
                            <h1 className={isRecruiter ? 'recruiter-title' : 'candidate-title'}>
                                {isRecruiter
                                    ? "Simplifique processos de recrutamento"
                                    : "Desenvolva a sua carreira"}
                            </h1>
                            <p className="header-desc">
                                {isRecruiter
                                    ? "Na Tonalida você centraliza todos os currículos. Nós divulgamos em todas as plataformas e a Tonia faz a primeira entrevista pelo App e analisa a compatibilidade."
                                    : "O App da Tonalida mostra vagas na sua região e permite que você se candidate totalmente grátis."}
                            </p>
                        </div>
                    </div>

                    {/* Green Part: Buttons */}
                    <div className="action-buttons-area">
                        {isRecruiter ? (
                            <CircularBtn
                                text="Anuncie vagas e entreviste com IA"
                                link={Links.portal}
                                variant="company"
                                className="full-width"
                            />
                        ) : (
                            <div className="buttons-row">
                                <CircularBtn
                                    text={<><FontAwesomeIcon icon={faFileAlt} style={{ marginRight: '8px' }} /> Cadastrar currículo</>}
                                    link="/criarcurriculo"
                                    variant="candidate"
                                />
                                <CircularBtn
                                    text={<><FontAwesomeIcon icon={faDownload} style={{ marginRight: '8px' }} /> Ver vagas</>}
                                    link={getDownloadLink()}
                                    variant="candidate"
                                    className="outline"
                                />
                            </div>
                        )}
                    </div>
                </div>
            </header>
        </WrapperComponent>
    );
};

export default BlogPostHeader;
